import { components } from "@/api-schema";
import { RowAction } from "@/components/ui/table-row-actions";
import { WrenchIcon } from "lucide-react";
import { RelocationOrderActionsContext } from "@/common/hooks/relocation-order/_helpers/relocation-order-actions-context";
import { isBranchRejectedStatus, isTransportCompanyRejectedStatus } from "./relocation-order-status-predicates";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function buildManagingBranchByOwnAxleActions(
  order: RelocationOrder,
  context: RelocationOrderActionsContext,
): RowAction[] {
  const actions: RowAction[] = [];

  const { status } = order;

  if (isBranchRejectedStatus(status)) {
    actions.push({
      label: context.t("fit:FixProblem"),
      icon: <WrenchIcon className="h-4 w-4" />,
      onClick: () => context.handleResolveBranchRejectedIssue(order),
    });
  }

  if (isTransportCompanyRejectedStatus(status)) {
    actions.push({
      label: context.t("fit:FixProblem"),
      icon: <WrenchIcon className="h-4 w-4" />,
      onClick: () => context.handleResolveTransportCompanyIssue(order),
    });
  }

  return actions;
}
